// extracted by mini-css-extract-plugin
export default {"breadcrumb":"breadcrumbview_breadcrumb__KeHdP"};